<svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_961_12072)">
<path d="M7.5 2.25L3.375 6.375L1.5 4.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_961_12072">
<rect width="9" height="9" fill="white"/>
</clipPath>
</defs>
</svg>
